export default __webpack_public_path__ + "static/media/isok.04bc659e.svg";